/* 
　【dAgora】住所変更用JS
 1) 郵便番号からの住所取得スクリプト（日本国内のみ対応）
 2) 新規登録時に国セレクタで日本をデフォルト設定
 3) 国セレクタのマッピングスクリプト
 4) ▼▼ 追加：Shopify向けの市区町村・住所1の整形（郡→町/村の分離）
 5) ▼▼ 追加：都道府県→ISO 3166-2 (Province Code) を算出し、noteやhiddenへ格納
ver管理
1.0 : 25/07/09　新規作成
1.1 : 25/11/04　整形/Province Code 追加
*/

/* ============================
 ユーティリティ
============================ */

// ▼▼ 追加：都道府県→Province Code（ISO 3166-2:JP）
const PREF_TO_PROVINCE_CODE = {
  "北海道":"JP-01","青森県":"JP-02","岩手県":"JP-03","宮城県":"JP-04","秋田県":"JP-05","山形県":"JP-06","福島県":"JP-07",
  "茨城県":"JP-08","栃木県":"JP-09","群馬県":"JP-10","埼玉県":"JP-11","千葉県":"JP-12","東京都":"JP-13","神奈川県":"JP-14",
  "新潟県":"JP-15","富山県":"JP-16","石川県":"JP-17","福井県":"JP-18","山梨県":"JP-19","長野県":"JP-20",
  "岐阜県":"JP-21","静岡県":"JP-22","愛知県":"JP-23","三重県":"JP-24",
  "滋賀県":"JP-25","京都府":"JP-26","大阪府":"JP-27","兵庫県":"JP-28","奈良県":"JP-29","和歌山県":"JP-30",
  "鳥取県":"JP-31","島根県":"JP-32","岡山県":"JP-33","広島県":"JP-34","山口県":"JP-35",
  "徳島県":"JP-36","香川県":"JP-37","愛媛県":"JP-38","高知県":"JP-39",
  "福岡県":"JP-40","佐賀県":"JP-41","長崎県":"JP-42","熊本県":"JP-43","大分県":"JP-44","宮崎県":"JP-45","鹿児島県":"JP-46","沖縄県":"JP-47"
};

// ▼▼ 追加：郡を含む場合の整形（市区町村と住所1の分割）
function normalizeJPAddressForShopify(municipality, townArea, prefecture) {
  const muni = (municipality || "").trim();
  const town = (townArea || "").trim();

  // 1) 東京都の特別区（例：東京都 世田谷区）
  //    → 市区町村 = 「世田谷区」, 住所1 = 町域以下
  if (prefecture === "東京都" && /^.+区$/.test(muni)) {
    return { city: muni, address1: town };
  }

  // 2) 政令指定都市の「◯◯市◯◯区」
  //    （例：横浜市青葉区 / 仙台市青葉区 / 札幌市中央区 など）
  //    → 市区町村 = 「◯◯市◯◯区」, 住所1 = 町域以下
  //    ※ “◯◯市”の直後に“◯◯区”が続く場合のみマッチ
  const mDesignated = muni.match(/^(.+市)(.+区)$/);
  if (mDesignated) {
    return { city: muni, address1: town };
  }

  // 3) 郡部：「◯◯郡◯◯町/村」だけを対象に厳密判定
  //    例：芳賀郡益子町 → 市区町村=「芳賀郡」 / 住所1=「益子町 + 町域」
  //    ※ 「郡山市」など“郡”を含む市名はここにマッチしない（末尾が町/村必須）
  const mGun = muni.match(/^(.+郡)(.+[町村])$/);
  if (mGun) {
    const gun = mGun[1].trim();       // ～郡
    const choSon = mGun[2].trim();    // ～町/村
    return { city: gun, address1: (choSon + town).replace(/\s+/g, "") };
  }

  // 4) 上記以外（一般的な「◯◯市」「◯◯区」「◯◯町」「◯◯村」など）
  //    → 市区町村 = municipality / 住所1 = 町域以下
  return { city: muni, address1: town };
}

// ▼▼ 追加：customer[note] に province_code を追記/更新（存在すれば置換、なければ追記）
function upsertProvinceCodeIntoNote(formEl, provinceCode) {
  if (!formEl || !provinceCode) return;

  // A) noteフィールド（input/textarea）を探す（従来の単一note用）
  let noteField = formEl.querySelector('textarea[name="customer[note]"], input[name="customer[note]"]');
  if (noteField) {
    const current = noteField.value || "";
    const line = `[province_code]=${provinceCode}`;
    if (/\[province_code\]=JP-\d{2}/.test(current)) {
      noteField.value = current.replace(/\[province_code\]=JP-\d{2}/, line);
    } else {
      noteField.value = current ? `${current}\n${line}` : line;
    }
  }

  // B) hidden群へ格納（今回のフォーム構成に合わせて拡張）
  const hiddenTargets = [
    '[id^="AddressProvinceCode_"]',
    'input[name="dagora[province_code]"]',
    'input[name="customer[note][province_code]"]' // ★ 追加：note配下の専用hidden
  ];
  hiddenTargets.forEach(sel => {
    const el = formEl.querySelector(sel);
    if (el) el.value = provinceCode;
  });
}

// ============================
// 郵便番号 → 住所自動入力（input/select 両対応）
// ============================

window.addEventListener('DOMContentLoaded', function () {
  const postalCodeInputs = document.querySelectorAll('input[id^="AddressZip_"], #AddressZip_register');

  if (!postalCodeInputs.length) {
    console.error('郵便番号入力フィールドが見つかりません');
    return;
  }

  postalCodeInputs.forEach(function (postalCodeInput) {
    let formId = postalCodeInput.id.replace('AddressZip_', '');
    if (postalCodeInput.id === 'AddressZip_register') formId = 'register';

    const prefectureField = document.getElementById(`AddressProvince_${formId}`);
    const cityField = document.getElementById(`AddressCity_${formId}`);
    const addressAddress1 = document.getElementById(`AddressAddress1_${formId}`);
    const addressDisplay = document.getElementById('AddressDisplay');

    if (!prefectureField || !cityField || !addressAddress1) {
      console.warn(`一部の住所フィールドが見つかりません（formId: ${formId}）`);
      return;
    }

    postalCodeInput.addEventListener('input', function () {
      const postalCode = postalCodeInput.value.replace('-', '').trim();

      if (postalCode.length === 7 && /^\d+$/.test(postalCode)) {
        fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`)
          .then(response => response.json())
          .then(data => {
            if (data.results) {
              const result = data.results[0];
              // ▼ 追加：都道府県・市区町村・町域を明示的に取り出す
              const prefecture  = (result.address1 || "").trim(); // 都道府県
              const municipality = (result.address2 || "").trim(); // 市区町村（郡/市/区を含む）
              const townArea    = (result.address3 || "").trim(); // 町域（丁目など）
              const fullAddress = `${prefecture} ${municipality} ${townArea}`.trim();

              // 都道府県：input or select 両対応
              if (prefectureField.tagName.toLowerCase() === 'select') {
                let matchFound = false;
                for (let i = 0; i < prefectureField.options.length; i++) {
                  if (prefectureField.options[i].text.trim() === result.address1.trim()) {
                    prefectureField.selectedIndex = i;
                    matchFound = true;
                    break;
                  }
                }
                if (!matchFound) {
                  console.warn(`都道府県「${result.address1}」に一致するoptionが見つかりません`);
                }
              } else {
                prefectureField.value = result.address1;
              }

              // ▼▼ 変更：Shopify向けの分割ロジック（定義済みの値を渡す）
              const normalized = normalizeJPAddressForShopify(municipality, townArea, prefecture);
              cityField.value = normalized.city;
              addressAddress1.value = normalized.address1;
              ['input','change'].forEach(evt => {
                cityField.dispatchEvent(new Event(evt, { bubbles: true }));
                addressAddress1.dispatchEvent(new Event(evt, { bubbles: true }));
              });

              // ▼▼ 追加：Province Code を算出し、note/hiddenへ格納
              const provinceCode = PREF_TO_PROVINCE_CODE[prefecture];
              const formEl = postalCodeInput.closest('form') || document;
              if (provinceCode) {
                upsertProvinceCodeIntoNote(formEl, provinceCode);
              }

              if (addressDisplay) {
                addressDisplay.textContent = `お住いの地域: ${fullAddress}`;
              }
            } else {
              if (addressDisplay) {
                addressDisplay.textContent = '住所が見つかりません。郵便番号を正しく入力してください。';
              }
            }
          })
          .catch(error => {
            console.error('住所取得エラー:', error);
            if (addressDisplay) {
              addressDisplay.textContent = '住所取得中にエラーが発生しました。';
            }
          });
      } else {
        if (addressDisplay) {
          addressDisplay.textContent = '郵便番号を正しく入力してください。';
        }
      }
    });
  });
});

// ============================
// 国セレクト：マッピング処理（アドレス帳向け、日本語 → ISO）
// ============================

document.addEventListener("DOMContentLoaded", function() {
  const countryMap = {
    "アイルランド": "Ireland",
    "アメリカ合衆国": "United States",
    "アラブ首長国連邦": "United Arab Emirates",
    "イギリス": "United Kingdom",
    "イスラエル": "Israel",
    "イタリア": "Italy",
    "オランダ": "Netherlands",
    "オーストラリア": "Australia",
    "オーストリア": "Austria",
    "カナダ": "Canada",
    "シンガポール": "Singapore",
    "スイス": "Switzerland",
    "スウェーデン": "Sweden",
    "スペイン": "Spain",
    "チェコ": "Czech Republic",
    "デンマーク": "Denmark",
    "ドイツ": "Germany",
    "ニュージーランド": "New Zealand",
    "ノルウェー": "Norway",
    "フィンランド": "Finland",
    "フランス": "France",
    "ベルギー": "Belgium",
    "ポルトガル": "Portugal",
    "ポーランド": "Poland",
    "マレーシア": "Malaysia",
    "中華人民共和国香港特別行政区": "Hong Kong",
    "日本": "Japan",
    "韓国": "South Korea"
  };

  const countrySelects = document.querySelectorAll('select[name="address[country]"]');
  countrySelects.forEach((selectElem, index) => {
    const defaultCountry = selectElem.getAttribute("data-default");
    if (defaultCountry) {
      const isoCountry = countryMap[defaultCountry];
      if (isoCountry) {
        selectElem.value = isoCountry;
      }
    }
  });
});

// ============================
// 国セレクト：会員登録画面など向け（value or text に一致）
// ============================
document.addEventListener('DOMContentLoaded', function () {
  const countrySelects = document.querySelectorAll('select[id^="AddressCountry_"], #AddressCountry_register');

  countrySelects.forEach(select => {
    const defaultValue = select.getAttribute('data-default');
    if (defaultValue) {
      for (let i = 0; i < select.options.length; i++) {
        const option = select.options[i];
        if (option.text.trim() === defaultValue || option.value.trim() === defaultValue) {
          select.selectedIndex = i;
          break;
        }
      }
    }
  });
});